import ContentLoader from 'react-content-loader'
import { useTheme } from 'styled-components'

export const LotCardLoader = () => {
  const theme = useTheme()
  return (
    <ContentLoader
      speed={2}
      width={252}
      height={500}
      viewBox="0 0 252 500"
      backgroundColor={theme.colours.grey[45]}
      foregroundColor={theme.colours.grey[30]}
    >
      <rect x="0" y="0" rx="4" ry="4" width="252" height="252" />
      <rect x="0" y="268" rx="4" ry="4" width="230" height="24" />
      <rect x="0" y="300" rx="4" ry="4" width="225" height="18" />
      <rect x="0" y="340" rx="4" ry="4" width="70" height="16" />
      <rect x="0" y="376" rx="4" ry="4" width="160" height="16" />
      <rect x="0" y="400" rx="4" ry="4" width="130" height="16" />
      <rect x="0" y="440" rx="4" ry="4" width="90" height="16" />
    </ContentLoader>
  )
}
